import { Table } from "antd";
import TableAntd from "components/elements/Table/Table";
import { useTranslation } from "react-i18next";

const EmployeeSalaryLiabilitiesTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
  onChange = () => { },
}) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: <div className="text-table">{t('employee.no')}</div>,
      dataIndex: "no",
      key: "no",
      align: "center",
    },
    {
      title: <div className="text-table">{t('translation.type')}</div>,
      dataIndex: "type",
      key: "type",
    },
    {
      title: <div className="text-table">{t('salary.label.first-payment-on-payroll-period')}</div>,
      dataIndex: "firstPaymentOnPayrollPeriod",
      key: "firstPaymentOnPayrollPeriod",
    },
    {
      title: <div className="text-table">{t('payment_period.label.period')}</div>,
      dataIndex: "period",
      key: "period",
    },
    {
      title: <div className="text-table">{t('salary.label.payment-amount')}</div>,
      dataIndex: "paymentAmount",
      key: "paymentAmount",
      align: "right",
    },
    {
      title: <div className="text-table">{t('salary.label.total-amount')}</div>,
      dataIndex: "totalAmount",
      key: "totalAmount",
      align: "right",
    },
    {
      title: <div className="text-table">{t('salary.label.balance')}</div>,
      dataIndex: "balance",
      key: "balance",
      align: "right",
    },
    {
      title: <div className="text-table">{t('employeeShift.table.lastModified')}</div>,
      dataIndex: "lastModified",
      key: "lastModified",
    },
    {
      title: <div className="text-table">{t('year_accumulate_list.label.status')}</div>,
      dataIndex: "status",
      key: "status",
    },
  ];

  return (
    <TableAntd
      loading={isLoading}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
      dataSource={dataSource}
      rowKey={(record) => record.id}
      columns={columns}
      onChange={onChange}
    />
  );
};

export default EmployeeSalaryLiabilitiesTable;
